<!-- 抽屉底部操作按钮组件 -->
<template>
  <div class="drawer-bottom">
    <div class="drawer-bottom-button">
      <el-button
        v-for="action in actions"
        :key="action.key"
        :type="action.type || 'default'"
        :loading="action.loading || false"
        :disabled="action.disabled || false"
        @click="handleAction(action)"
      >
        {{ action.text }}
      </el-button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  actions: {
    type: Array,
    default: () => [],
  },
})

const emits = defineEmits(['action'])

const handleAction = (action) => {
  emits('action', action.key, action)
}
</script>

<style lang="scss" scoped>
.drawer-bottom {
  width: 100%;
  text-align: right;
  position: fixed;
  bottom: 0;
  right: 20px;
  background: #F3F3F4;
  z-index: 999;

  .drawer-bottom-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin: 20px 0;
  }
}
</style>
